<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">X</span></button>
      <h2 class="layerTitle">마이콜렉션 내역</h2>
      <div class="myCollectionSnapshotList">
        <table>
          <thead>
            <th>버전</th>
            <th>저장일시</th>
            <th class="memo">메모</th>
            <th></th>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in list"
              :key="index">
              <td>{{ item.snapShotVersion }}</td>
              <td class="datetime">{{ datetimeFormat(item.createat) }}</td>
              <td class="memo">{{ item.memo || '-' }}</td>
              <td>
                <button
                  type="button"
                  class="btn btnWhite btnRound btnAuto sizeS"
                  @click.stop="loadMyCollectionSnapshot(item.snapShotVersion)">
                  불러오기
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.close }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment/moment'

export default {
  name: 'MyCollectionSnapshot',
  props: [
    'locale',
    'lang',
    'pageId',
    'list'
  ],
  computed: {
    room () {
      return this.$store.state.authentication.space
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
  },
  data () {
    return {
      isActive: false,
      hideTimer: null
    }
  },
  methods: {
    datetimeFormat (isoString) {
      const datetime = DateTime.fromISO(isoString || moment().toISOString(), { zone: this.timezone })
      const result = datetime.toFormat(this.format)
      return result.replace(' ', '\n')
    },
    getSnapshot (snapShotVersion) {
      // 현재 마이콜렉션이 버전이 있으면 그대로 해당버전 load, 버전이 null이면 현재 콜렉션을 저장한 뒤 해당 버전 load 해야함
      this.$emit('getSnapshot', snapShotVersion)
      this.close()
    },
    async loadMyCollectionSnapshot (snapShotVersion) {
      const data = {
        pageId: this.pageId,
        snapShotVersion: snapShotVersion
      }
      const res = await this.$store.dispatch('collection/loadMyCollectionSnapshot', data)
      if (res && res.status === 200) {
        this.$store.commit('collection/setRequestMyCollection', true)
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.myCollectionSnapshotList {
  overflow: hidden;
  letter-spacing: 0;
  border: 1px solid $color-lgrey2;
  border-radius: 8px;
  th,
  td {
    padding: 8px 4px;
    text-align: center;
    &:first-of-type {
      padding-left: 12px;
    }
    &:last-of-type {
      text-align: right;
      padding-right: 12px;
    }
  }
  th {
    padding-top: 12px;
    padding-bottom: 12px;
    color: $color-grey;
    background-color: $bg-default;
  }
  td {
    border-top: 1px solid $color-lgrey2;
  }
  .datetime {
    display: table-cell;
    white-space: pre-line;
    font-size: 12px;
    line-height: 1.2;
  }
  .memo {
    text-align: left;
    width: 240px;
  }
}
.layer {
  .btns {
    max-width: 240px;
    font-size: inherit;
    margin: 30px auto 0;
  }
}
</style>